// src/Interact.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageRenderer from './PageRenderer';
import { fetchPageBySlug } from './Api';
import Overlay from '../overlay/Overlay'; // <--- Overlay-Komponente importieren

function Interact() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- State für das Popup hinzufügen ---
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const handleOpenPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  // --- useEffect für das Laden der Seite (bestehend) ---
  useEffect(() => {
    const getPage = async () => {
      try {
        setLoading(true);
        const data = await fetchPageBySlug(slug); // 🔥 Slug wird hier verwendet
        if (data) {
          setPageData(data);
        } else {
          setError('Seite nicht gefunden oder Daten fehlerhaft.');
        }
      } catch (err) {
        setError('Fehler beim Laden der Daten.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    getPage();
  }, [slug]); // Abhängigkeit von slug, damit bei Slug-Änderung neu geladen wird

  // --- NEUER useEffect HOOK FÜR DAS ZEITGESTEUERTE POPUP ---
  useEffect(() => {
    let showTimer;
    let hideTimer;

    // Nur das Popup anzeigen, wenn der Slug 'main-page' ist
    if (slug === 'test') {
      // Timer, um das Popup nach 3 Sekunden anzuzeigen
      showTimer = setTimeout(() => {
        handleOpenPopup(
          <div>
            <h3>Willkommen bei Great Spirits!</h3>
            <p>Diese Seite ist ein Beispiel.</p>
            <p>Alle Inhalte sind fiktiv.</p>
            <p>Entdecken Sie, wie Ihre eigene Website aussehen könnte!</p>
          </div>
        );
      }, 3000); // 3000 ms = 3 Sekunden Verzögerung zum Anzeigen

      // Timer, um das Popup nach weiteren 3 Sekunden auszublenden
      hideTimer = setTimeout(() => {
        handleClosePopup();
      }, 6000); // 6000 ms = 6 Sekunden nach dem Laden der Seite (3s anzeigen + 3s sichtbar)
    }

    // Cleanup-Funktion: Wichtig, um Memory Leaks zu vermeiden
    // und um sicherzustellen, dass Timer gelöscht werden, wenn die Komponente unmounted wird
    // oder wenn der slug sich ändert (und der Effekt neu ausgeführt wird)
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [slug]); // Abhängigkeit von slug, damit der Effekt bei Slug-Änderung neu bewertet wird

  if (loading) return <div className="container py-4">Lade Seite...</div>;
  if (error) return <div className="container py-4 text-danger">Fehler: {error}</div>;
  if (!pageData) return <div className="container py-4">Keine Daten gefunden.</div>;

  const { sections, Background } = pageData;

  return (
    <div>
      <PageRenderer sections={sections} Background={Background} />

      {/* Das Overlay wird hier gerendert */}
      <Overlay isOpen={isPopupOpen} onClose={handleClosePopup}>
        {popupContent} {/* Der dynamisch gesetzte Inhalt wird hier angezeigt */}
      </Overlay>
    </div>
  );
}

export default Interact;
